<template>
    <div id="selector">
        <!-- <button class="iconBigBtn" v-bind:class="{'closedForm': !toggle, 'openForm': toggle}" @click='toggle = !toggle'>
            <div v-bind:class="{'nonshippable': !toggle, 'shippable': toggle}" class="iconBtn"><font-awesome-icon icon="shipping-fast" /> </div>
            <div v-bind:class="{'shippable': !toggle, 'nonShippable': toggle}" class="iconBtn"><font-awesome-icon icon="shopping-basket" /> </div>  
            <div v-bind:class="{'nonshippable': !toggle, 'shippable': toggle}" class="textBtn">{{ $t('offerGuestDelivery') }}</div>
            <div v-bind:class="{'shippable': !toggle, 'nonShippable': toggle}" class="textBtn">{{ $t('NOofferGuestDelivery') }}</div>
        </button> -->
        <ToggleShippable @delivery-changed="toggleAddressForm"/>
        <div v-show='toggle'>
            <div class="price-wrapper borderline">
                <h4 data-qa="shippingDataLabel">{{ $t('packageDetails') }}</h4>
				<p data-qa="shippingDetailsText" class="limitPickUp">{{ $t('packageLimits') }}</p>
                <div>
                    <div>
                        <label data-qa="shippingWeightLabel">{{ $t('weight') }}:</label>
                        <input
                            v-model="weight"
                            class="fieldPrice inp"
                            :class="{ errorBg: $v.weight.$error }"
                            type="number"
							maxlength="3"
							min="1"
							step="1"
                            name="weight"
                            @blur="$v.weight.$touch()"
                            @keyup="preventFirstZero($event)"
                            @change="sendData"
							data-qa="shippingWeightInput"
                        >
                        <span data-qa="shippingWeightUnitLabel">kg</span>
                    </div>
                    <div>
                        <label data-qa="shippingHeightLabel">{{ $t('height') }}:</label>
                        <input
                            v-model="height"
                            class="fieldPrice inp"
                            :class="{ errorBg: $v.height.$error }"
                            type="number"
							maxlength="3"
							min="1"
							step="1"
                            name="height"
                            @blur="$v.height.$touch()"
                            @keyup="preventFirstZero($event)"
                            @change="checkPackageDimensions"
							data-qa="shippingHeightInput"
                        >
                        <span data-qa="shippingHeightUnitLabel">cm</span>
                    </div>
                </div>
                <div>
                    <div>
                        <label data-qa="shippingWidthLabel">{{ $t('width') }}:</label>
                        <input
                            v-model="width"
                            class="fieldPrice inp"
                            :class="{ errorBg: $v.width.$error }"
                            type="number"
							maxlength="3"
							min="1"
							step="1"
                            name="width"
                            @blur="$v.width.$touch()"
                            @keyup="preventFirstZero($event)"
                            @change="checkPackageDimensions"
							data-qa="shippingWidthInput"
                        >
                        <span data-qa="shippingWidthUnitLabel">cm</span>
                    </div>
                    <div>
                        <label data-qa="shippingLengthLabel">{{ $t('length') }}:</label>
                        <input
                            v-model="length"
                            class="fieldPrice inp"
                            :class="{ errorBg: $v.length.$error }"
                            type="number"
							maxlength="3"
							min="1"
							step="1"
                            name="length"
                            @blur="$v.length.$touch()"
                            @keyup="preventFirstZero($event)"
                            @change="sendData"
							data-qa="shippingLengthInput"
                        >
                        <span data-qa="shippingLengthUnitLabel">cm</span>
                    </div>
                </div>

                <!-- <template v-if="$v.weight.$error">
                    <p v-if="!$v.weight.required" class="errorMessage">{{ $t('weightReq') }}</p>
                </template>
                <template v-if="$v.height.$error || !$v.width.$error || !$v.length.$error">
                    <p v-if="!$v.height.required || !$v.width.required  || !$v.length.required" class="errorMessage">{{ $t('measurementReq') }}</p>
                </template> -->
                <!-- <template v-if="$v.width.$error">
                    <p v-if="!$v.width.required" class="errorMessage">{{ $t('measurementReq') }}</p>
                </template>
                <template v-if="$v.length.$error">
                    <p v-if="!$v.length.required" class="errorMessage">{{ $t('measurementReq') }}</p>
                </template> -->
            </div>

            <br/>

            <div class="borderline">
                <h4 data-qa="pickUpAddressTitle">{{ $t('pickUpAddress') }}</h4>
				<div class="address-wrapper">
                    <input
                        v-model="pickUpAddress"
                        class="field inp"
                        :class="{ errorBg: $v.pickUpAddress.$error }"
                        type="text"
                        name="pickUpAddress"
                        ref="autocomplete"
                        maxlength="100"
                        @change="sendData"
                        @blur="$v.pickUpAddress.$touch()"
                        :placeholder="$t('address')"
						data-qa="pickUpAddressInput"
					/>	                
					<template v-if="$v.pickUpAddress.$error">
                    	<p v-if="!$v.pickUpAddress.required" class="errorMessage">{{ $t('addressReq') }}</p>
                	</template>
					<div class="price-wrapper">
						<div>
							<input
								v-model="pickUpCode"
								class="field fieldZipCode inp"
								:class="{ errorBg: $v.pickUpCode.$error }"
								type="text"
								name="pickUpCode"
								maxlength="10"
								@change="sendData"
								@blur="$v.pickUpCode.$touch()"
								:placeholder="$t('postalCode')"
								data-qa="pickUpPostalCodeInput"
							/>
						</div>
						<!-- <template v-if="$v.pickUpCode.$error">
							<p v-if="!$v.pickUpCode.required" class="errorMessage">{{ $t('postalCodeReq') }}</p>
						</template> -->
						<div>
							<input
								v-model="pickUpCity"
								class="field fieldPrice2 inp"
								:class="{ errorBg: $v.pickUpCity.$error }"
								type="text"
								name="pickUpCity"
								maxlength="25"
								@change="sendData"
								@blur="$v.pickUpCity.$touch()"
								:placeholder="$t('city')"
								data-qa="pickUpCityInput"
							/>
						</div>
						<!-- <template v-if="$v.pickUpCity.$error">
							<p v-if="!$v.pickUpCity.required" class="errorMessage">{{ $t('cityReq') }}</p>
						</template>  -->
					</div>					
                    <country-select 
                        :country="pickUpCountry" 
                        v-model="pickUpCountry" 
                        class="field inputStyle"
                        topCountry="SI"
                        :countryName="true"
                        :autocomplete="true"
                        :removePlaceholder="true"
                        :usei18n="false"
                        @change="sendData"
                        @blur="$v.pickUpCountry.$touch()"
						data-qa="pickUpCountryInput"
                    />					
				</div>
            </div>
        </div>
    
    </div>
</template>

<script>

import { required } from 'vuelidate/lib/validators'
import ToggleShippable from '../common/ToggleShippable'

export default {
    name: "selector",
    components: {
        ToggleShippable
    },
    data() {
        return {
            toggle: true,
            weight: '',
            height: '',
            width: '',
            length: '',
            pickUpAddress: '',
            pickUpCode: '', 
            pickUpCity: '',
            pickUpCountry: '',
            widget: null,
            isDimensionValid: false
        }
    },
    validations: {
        weight: { required },
        height: { required },
        width: { required },
        length: { required },
        pickUpAddress: { required },
        pickUpCode: { required },
        pickUpCity: { required },
        pickUpCountry: { required }
    },
    methods: {
        toggleAddressForm(toggle) {
            this.toggle = toggle
            this.sendData()
        },
        sendData() {
            if (this.toggle) {
                this.$emit('shipping-details', {
                    pkg_weight: this.weight,
                    pkg_height: (this.$v.$invalid || (this.toggle && !this.isDimensionValid)) ? '' : this.height,
                    pkg_width: (this.$v.$invalid || (this.toggle && !this.isDimensionValid))? '' : this.width,
                    pkg_length: this.length,
                    pickup_address: this.pickUpAddress,
                    pickup_postal_code: this.pickUpCode,
                    pickup_city: this.pickUpCity,
                    pickup_country: this.pickUpCountry,
                    shippable: this.toggle
                })
            } else {
                this.$emit('shipping-details', {
                    shippable: this.toggle
                })
            }
        },
        preventFirstZero(event) {
            event.target.value = parseInt(event.target.value) === 0  ? null : event.target.value
        },
        checkPackageDimensions() {
            this.isDimensionValid = false
            const width = this.width
            const height = this.height
            if (width && height) {
                if ((height >= 11 && width >= 15) || (width >= 11 && height >= 15)) {
                    this.isDimensionValid = true
                } else if ((height >= 11 && width < 15) || (width >= 11 && height < 15) || (width <= 11 && height <= 11)) {
                    alert(this.$t('packageLimits'))
                }
            }
            this.sendData()
        }
    },
    mounted() {
        this.sendData();
        this.widget = new window.google.maps.places.Autocomplete(
          (this.$refs.autocomplete),
          {types: ['geocode']});
          this.widget.addListener('place_changed', () => {
            this.pickUpCode = ''
            this.pickUpCity = ''
            this.pickUpCountry = ''
            this.pickUpAddress = this.$refs.autocomplete.value;
            const placeDetails = this.widget.getPlace();
            placeDetails.address_components.forEach(addressComp => {
              if(addressComp.types.includes('locality')) this.pickUpCity = addressComp.long_name;
              if(addressComp.types.includes('postal_code')) this.pickUpCode = addressComp.long_name;
              if(addressComp.types.includes('country')) this.pickUpCountry = addressComp.long_name;
            });
            this.sendData();
        });
    }    
}
</script>

<style lang="scss" scoped>

.login-btn{
  color: var(--primary) !important;
  border: 1px solid var(--primary);
  background: none;
  text-decoration: none;
  text-transform: uppercase;
  font-weight: 500;
  letter-spacing: 2px;
  padding: 10px 20px;
  border-radius: 5px;
  transition: 0.3s;
  transition-property: background;
}

.login-btn:hover{
  background: var(--primary);
  color: var(--bright) !important;
}

.closedForm {
    background-color: var(--primary);
}
.openForm{
    background-color: var(--bg);
}
.shippable {
   display: none;
}
.nonShippable{
    display: block;
}
.errorMessage {
  font-size: 0.8em;
  margin-top: -10px;
  color: var(--primaryDark);
}
.field {
  width: 80%;
}
.fieldZipCode {
  width: 50%;
  margin: 0px 25px 0px 0px;

}
.errorBg {
  background-color: var(--primarySuperLight) !important;
  // border-color: none;
  border-bottom: 0.2px solid var(--primary);
}
.borderline {
    border: solid 1px var(--bg);
    padding: 10px;
}
.iconBigBtn {
    margin: 40px auto 10px auto;
    display: flex;
    border: none;
    outline: none;
    border-radius: 5px;
    align-items: center;
    height: 100px;
    width: 300px;
    padding: 15px;
}

.iconBtn {
    font-size: 3em;
    padding: 5px;
    margin-right: 10px;
    color: var(--bright);
}
.textBtn {
    color: var(--bright);
    text-align: left;
    padding: 5px;
}
.fieldPrice {
  width: 30%;
} 

section label {
  color: var(--primary);
  font-weight: 600;
}

.price-wrapper {
  display: flex;
}

.price-wrapper span {
  font-weight: 600;
  font-size: 1.3em;
  margin-left: 5px;
  color: var(--bg);
}
.stockInput span {
  font-weight: 600;
  font-size: 1.0em;
  margin-left: 5px;
  color: var(--bg);
}

.questionMark {
  color: var(--bright) !important;
  border-radius: 50% !important;
  border: none;
  background-color: var(--bg) !important;
  padding: 2px 6px !important;
  margin-left: 5px !important; 
  margin-right: 3px !important;
}

.questionMark:hover {
  background-color: var(--primary) !important;
}
.inp {
    border:none;
    border-bottom: 0.2px solid var(--bg);
    padding: 5px 10px;
    outline: none;
    margin-bottom: 1.2em;
    background-color: var(--grey-superlight);
 }
 .inp:hover {
   border-color: var(--primary);
 }

 @media screen and (min-width: 500px){
 .address-wrapper {
	text-align: left;
    margin-left: 20px;
 }
 }
@media screen and (max-width: 500px){
.iconBigBtn {
    margin: 10px auto 4px auto;
    display: block;
    height: auto;
    width: 100%;
    padding: 5px;
}
.iconBtn {
    font-size: 2.5em;
    margin-right: 0px;
    margin: 0;
    padding: 0;
}
.textBtn {
    text-align: center;
    font-size: 0.8em;
}
.price-wrapper {
  display: block;
}
.price-wrapper span {
  font-size: 0.9em;
}
.field {
  width: 100%;
}
section label {
line-height: 1.2em;
}
}
</style>

<style>
/* global styles */
.pac-container {
    z-index: 1042 !important;
}
</style>